const cols = [];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-100 px-6 md:px-10 pt-16 pb-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 pb-12 border-b border-background-50/10">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-2.5 mb-5">
            <div className="w-10 h-10 rounded-xl bg-primary-500 flex items-center justify-center overflow-hidden">
              <div className="w-6 h-6 relative">
                <div className="absolute inset-0 bg-background-50" style={{ clipPath: 'polygon(0 0, 55% 0, 100% 50%, 55% 100%, 0 100%, 20% 50%)' }}></div>
              </div>
            </div>
            <div>
              <p className="text-background-50 font-bold text-lg leading-tight">VF Money</p>
              <p className="text-background-100/70 text-[11px] uppercase tracking-widest">
                CÔNG TY CỔ PHẦN KINH DOANH VF MONEY
              </p>
            </div>
          </div>
          <p className="text-background-100/80 text-sm leading-relaxed mb-6 max-w-sm">
            VF Money – Dịch vụ vay tiêu dùng online hợp pháp, được tin tưởng bởi hơn 5.000
            khách hàng trên khắp Việt Nam.
          </p>

          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <i className="ri-time-line text-primary-400 mt-0.5"></i>
              <span>8:30 - 18:00 (Thứ Hai - Chủ Nhật)</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-background-100/70 text-xs">
          © 2026 VF MONEY BUSINESS JOINT STOCK COMPANY. All rights reserved.
        </p>
        <div className="flex items-center gap-5 text-xs text-background-100/70">
          <a href="#" rel="nofollow" className="hover:text-background-50 cursor-pointer whitespace-nowrap">
            Điều khoản
          </a>
          <a href="#" rel="nofollow" className="hover:text-background-50 cursor-pointer whitespace-nowrap">
            Bảo mật
          </a>
          <a href="#" rel="nofollow" className="hover:text-background-50 cursor-pointer whitespace-nowrap">
            Sitemap
          </a>
        </div>
      </div>
    </footer>
  );
}